/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/bestellung.ts.
 */
import {User} from './user';
import {Subbestellung} from './subbestellung';

/**
 * Zweck: Beschreibt class Bestellung und ihren Daten- oder Funktionsvertrag.
 */
export class Bestellung {
  id: number;
  label: string;
  note: string;
  subbestellungen: Subbestellung[];
  shared: boolean;
  locked: boolean;
  agbaccepted: boolean;
  artikel_count: number;
  wert_summe: number;
  owner: boolean;
  owner_user: User;
  send: boolean;
  response: any;
  lieferkunde_nr: string;
  kunde_nr: string;
  hasErrors: boolean;
  valutaDate: string;
  reTage: string;
  liefernAb: string;
  supplierId: string;
  supplierLabel: string;
  commType: string;
  orderType: string;
  dtpError: boolean;
  externeKopfreferenz: string;
  sortierkennzeichen: string;

  ts_insert: string;


  view_collapsed = true;
}
